// DevBannerDrawer.tsx
import { SwipeableDrawer, Box, Typography, Link } from "@mui/material";

export default function DevBannerDrawer({
  bannerHeight,
}: {
  bannerHeight: number;
}) {
  return (
    <SwipeableDrawer
      anchor="top"
      open // permanently open
      onOpen={() => {}}
      onClose={() => {}}
      hideBackdrop
      disableSwipeToOpen // can't re‑open by swiping
      disableScrollLock // body can still scroll
      ModalProps={{
        keepMounted: true,
        disableEnforceFocus: true,
        sx: { pointerEvents: "none" }, // clicks pass through
      }}
      PaperProps={{
        sx: {
          pointerEvents: "auto",
          height: bannerHeight,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#ffff33",
          borderBottom: (t) => `1px solid ${t.palette.warning.main}`,
          zIndex: (t) => t.zIndex.appBar + 1,
        },
      }}
    >
      <Box sx={{ width: "100%", textAlign: "center" }}>
        <Typography variant="h6" color="#dd0f0f">
          This is a <strong>development</strong> environment. Visit the
          production site&nbsp;
          <Link
            href="https://www.niap-ccevs.org/"
            underline="always"
            color="inherit"
          >
            <strong>here</strong>
          </Link>
          .
        </Typography>
      </Box>
    </SwipeableDrawer>
  );
}
